import { log } from './log';

/** No idea what this actually does. 🤷🏻‍♂️ */
export function prepareScopeUpdate()
{
    log('info', 'lifecycle::prepareScopeUpdate');
}
